import { ACCORDION_TITLE_COPY_LIMITS } from "../copy-policy";
export const accordionSchema = {
    componentId: "Accordion",
    scalarSlots: [],
    mediaSlots: [],
    repeatSlots: [
        {
            key: "tabs",
            label: "Tabs (optional)",
            itemLabel: "Tab",
            scalarSlots: [{ key: "label", label: "Tab label", type: "text" }],
            mediaSlots: [],
        },
        {
            key: "sections",
            label: "Sections (optional)",
            itemLabel: "Section",
            scalarSlots: [
                { key: "label", label: "Section name", type: "text" },
                {
                    key: "title",
                    ...ACCORDION_TITLE_COPY_LIMITS,
                    label: "Section title (optional)",
                    type: "text",
                },
                { key: "tabId", label: "Tab", type: "select", optionsRepeat: "tabs" },
            ],
            mediaSlots: [],
        },
        {
            key: "entries",
            label: "Entries",
            itemLabel: "Entry",
            minItems: 1,
            scalarSlots: [
                {
                    key: "title",
                    ...ACCORDION_TITLE_COPY_LIMITS,
                    label: "Title",
                    type: "text",
                },
                {
                    key: "sectionId",
                    label: "Section",
                    type: "select",
                    optionsRepeat: "sections",
                },
            ],
            mediaSlots: [],
            documentSlots: [{ key: "body", label: "Body" }],
        },
    ],
};
//# sourceMappingURL=accordion.js.map